<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="xl" :visible="modal.show"
                   :title="$t(`Add Customers to Audience`)"
                   @show="onShow" @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)"
                   :ok-title="btnText" :is-loading="loading"
                   :content-in-form="false" scrollable
                   :disable-submit-btn="customerTableData && customerTableData.rows.length === 0">
      <CustomerTable hide-actions :exclude-columns="['address', 'phone', 'status', 'company_name']"
                     :exclude-search-fields="['company_name', 'personal_id', 'phone', 'address_info', 'tags',]"
                     :selectable="true" @selectedItemsChange="onSelectedItemsChange" :with-initial-data="false"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import CustomerTable from "@/modules/customer/CustomerTable";
  import MarketingService from "@/modules/marketing/MarketingService";
  import {SOURCE_AUDIENCES_CUSTOMERS_LIST} from "@/modules/constants";
  import {hasPermission} from "@/core/directives/permission";

  const {mapState, mapActions} = createNamespacedHelpers('marketing/audience');
  const {mapActions: customerMapActions, mapState: customerMapState} = createNamespacedHelpers('customer');

  export default {
    name: "AudienceCustomersModal",
    components: {
      CustomerTable,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        selectedItems: new Set()
      }
    },
    computed: {
      ...mapState({
        modal: state => state.view.audienceCustomersModal,
        audience: state => state.view.audience
      }),
      ...customerMapState({
        customerTableData: state => state.tableData[state.tableSource]
      }),
      btnText() {
        if (this.selectedItems.size === 0) {
          return this.$i18n.t('Add All Customer to Audience');
        } else {
          return this.$i18n.t('Add {count} Customer(s) to Audience', {count: this.selectedItems.size});
        }
      }
    },
    methods: {
      ...mapActions(['hideAudienceCustomersModal', 'updateViewAudience']),
      ...customerMapActions(['updateTableSource', 'getTableParams','getTableData']),
      async onShow() {
        await this.updateTableSource({
          source: 'audienceCustomersModal',
          clearTableData: true,
          expand: 'activity,interest_categories' + (hasPermission('view_customeraddress') ? ',display_billing_address' : '')
        });
        await this.getTableData();
      },
      onHidden() {
        this.selectedItems = new Set();
        this.hideAudienceCustomersModal();
      },
      async onSubmit() {
        let question = this.$i18n.t("Are you sure you want to add {count} customer(s) to following audience?", {count: this.selectedItems.size});
        if (this.selectedItems.size === 0) {
          question = this.$i18n.t("Are you sure you want to add all customers to following audience ?");
        }

        let success = await this.$confirm(question);
        if (success) {
          let requestData;

          if (this.selectedItems.size === 0) {
            requestData = {filter_params: await this.getTableParams()};
          } else {
            requestData = {customer_uuids: []};
            this.selectedItems.forEach(c => requestData.customer_uuids.push(c.uuid));
          }

          this.loading = true;
          let response = await MarketingService.addCustomersToAudience(this.audience.uuid, requestData, 'customers');
          this.loading = false;

          if (response.success) {
            this.hideAudienceCustomersModal();
            if (this.modal.source === SOURCE_AUDIENCES_CUSTOMERS_LIST) {
              this.updateViewAudience(response.body);
            }
          } else {
            if (response.body.non_field_errors) {
              this.$errorDialog(response.body.non_field_errors[0]);
            }
          }
        }
      },
      onSelectedItemsChange(selectedItems) {
        this.selectedItems = selectedItems;
      }
    },
  }
</script>

<style scoped lang="scss">
  /deep/ div.table-sm.table-responsive {
    max-height: 450px;
  }
</style>
